import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  NEW_CUSTOMER_TOTAL_COUNT,
} from "../../../Constants/Config";

import { ciUrl } from "../../../Constants/nodeCi";
const initialState = {
  loading: false,
  totalCustomersCount: 0,
  totalRevenue: 0,
  status: false,
  error: "",
};

let cancelTokenSource = null;

export const fetchCustomerTotals = createAsyncThunk(
  "customerTotal/fetchCustomerTotals",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    cancelTokenSource = axios.CancelToken.source();

    try {
      const { token, ...payload } = data || {};

      const response = await axios.post(
        ciUrl(NEW_CUSTOMER_TOTAL_COUNT),
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token ? `Bearer ${token}` : undefined,
          },
          cancelToken: cancelTokenSource.token,
        }
      );

      const res = response.data;
      // return;

      if (res?.status) {
        const totalCustomersCount =
          res?.result?.total_count ? res?.result?.total_count : 0;
        const totalRevenue =
          res?.result?.total_lifetime_order_amt ?
            res?.result?.total_lifetime_order_amt :
            0;

        return {
          status: true,
          totalCustomersCount,
          totalRevenue,
        };
      } else {
        return {
          status: false,
          totalCustomersCount: 0,
          totalRevenue: 0,
        };
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        return { status: false, totalCustomersCount: 0, totalRevenue: 0 };
      }

      const customError = {
        message: error?.message || "An error occurred",
        status: toThunkRejectValue(error).status,
        data: error?.response?.data || null,
      };
      return rejectWithValue(customError);
    }
  }
);

const customerTotalSlice = createSlice({
  name: "customerTotal",
  initialState,
  reducers: {
    clearCustomerTotals: (state) => {
      state.loading = false;
      state.totalCustomersCount = 0;
      state.totalRevenue = 0;
      state.status = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerTotals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchCustomerTotals.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action.payload?.status ?? false;
      state.totalCustomersCount = action.payload?.totalCustomersCount ?? 0;
      state.totalRevenue = action.payload?.totalRevenue ?? 0;
      state.error = "";
    });
    builder.addCase(fetchCustomerTotals.rejected, (state, action) => {
      state.loading = false;
      state.status = false;
      state.totalCustomersCount = 0;
      state.totalRevenue = 0;
      const errorMessage =
        action.payload?.message || action.error?.message || "An error occurred";
      state.error =
        typeof errorMessage === "string"
          ? errorMessage
          : JSON.stringify(errorMessage);
    });
  },
});

export const { clearCustomerTotals } = customerTotalSlice.actions;
export default customerTotalSlice.reducer;

